import React,{useRef, useState, useEffect, useContext} from "react";
import {X, CircleNotch, Info, Eye} from "@phosphor-icons/react";
import layerEvents from "../utils/layerEvents";
import vindrApi from "../utils/vindrapi";
import { Col, Row, Modal, Button} from "react-bootstrap";
import EditableRange from "../components/EditableRange";
import globalContext						from "../utils/globalContext";




const scaleWorst = [
	{
		color: "#2920CD",
		opacity: .2,
		label: "0-10 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .4,
		label: "10-30 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .6,
		label: "30-100 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .8,
		label: "100+ hours / year"
	}
];

const scaleReal = [
	{
		color: "#2920CD",
		opacity: .2,
		label: "0-4 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .4,
		label: "4-8 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .6,
		label: "8-30 hours / year"
	},
	{
		color: "#2920CD",
		opacity: .8,
		label: "30+ hours / year"
	}
];

const getScale = (method) => method === 'REAL' ? scaleReal : scaleWorst;

const paintOpacity = (scale, method)=>{
	if(method === 'REAL'){
		return {
			'fill-opacity': ['case',
				['<', ['get', 'hours'], 4], scale[0].opacity,
				['all', ['>=', ['get', 'hours'], 4],['<', ['get', 'hours'], 8]], scale[1].opacity,
				['all', ['>=', ['get', 'hours'], 8],['<', ['get', 'hours'], 30]], scale[2].opacity,
				['>=', ['get', 'hours'], 30], scale[3].opacity,

				1
			]
		};
	}
	return {
		'fill-opacity': ['case',
			['<', ['get', 'hours'], 10], scale[0].opacity,
			['all', ['>=', ['get', 'hours'], 10],['<', ['get', 'hours'], 30]], scale[1].opacity,
			['all', ['>=', ['get', 'hours'], 30],['<', ['get', 'hours'], 100]], scale[2].opacity,
			['>=', ['get', 'hours'], 100], scale[3].opacity,

			1
		]
	};
};


const getLayerPaint = (method) => {
	const scale = getScale(method);
	if(method === 'REAL'){
		return {
			'fill-color': ['case',
				['<', ['get', 'hours'], 4], scale[0].color,
				['all', ['>=', ['get', 'hours'], 4],['<', ['get', 'hours'], 8]], scale[1].color,
				['all', ['>=', ['get', 'hours'], 8],['<', ['get', 'hours'], 30]], scale[2].color,
				['>=', ['get', 'hours'], 30], scale[3].color,

				'#2920CD'
			],
			...paintOpacity(scale, method)
		};
	}
	return {
		'fill-color': ['case',
			['<', ['get', 'hours'], 10], scale[0].color,
			['all', ['>=', ['get', 'hours'], 10],['<', ['get', 'hours'], 30]], scale[1].color,
			['all', ['>=', ['get', 'hours'], 30],['<', ['get', 'hours'], 100]], scale[2].color,
			['>=', ['get', 'hours'], 100], scale[3].color,

			'#2920CD'
		],
		...paintOpacity(scale, method)
	};
};


export default function OverlayShadow({onClose}){


	const layerId = 'shadow-fill';
	const sourceId = 'shadow-source';

	const [shadowData, setShadowData]		= useState(null);
	const [opacity, setOpacity]				= useState(100);
	const [hiddenBands, setHiddenBands]		= useState(new Set());
	
	const context							= useContext(globalContext);
	const tc								= context.tc;
	const map								= tc.map;




	useEffect(() => {
		getShadowLayer();
		tc.sensorModeForce();
		tc.updatePanelLayer = getShadowLayer;
		return ()=>{
			remLayer();
			delete tc.updatePanelLayer;
		}
	}, []); 
	
	
	const handleOpacityChange = (opc) => {
		setOpacity(opc);
		setLayerOpacity(layerId, opc/100);
	}
	
	const handleToggleBand = (index) => {
		const next = new Set(hiddenBands);
		if (next.has(index)) next.delete(index);
		else next.add(index);
		setHiddenBands(next);

		if (map.getLayer(layerId)) {
			const method = shadowData.method;
			const scale = getScale(method).map((s, i) => ({
				...s,
				opacity: next.has(i) ? 0 : s.opacity * (opacity / 100)
			}));
			const op = paintOpacity(scale, method);
			map.setPaintProperty(layerId, 'fill-opacity', op['fill-opacity']);
		}
	}

	const addLayer = (data) => {
		if(!data?.isolines)
			return;

		if(!map.getSource(sourceId)){
			map.addSource(sourceId, {
				type: 'geojson',
				data: data.isolines
			});

			//set the opacity if there is a preset
			map.addLayer({
				id: layerId,
				type: 'fill',
				source: sourceId,
				paint: getLayerPaint(data.method)
			});

			map.moveLayer(layerId);	

		}
		
	}
	const remLayer = () => {
		
		if(!map.getSource(sourceId))
			return;
		

		if(map.getLayer(layerId))
			map.removeLayer(layerId);
		
		if(map.getSource(sourceId))
			map.removeSource(sourceId);
		
		
	}
	const getShadowLayer = () => {
		
		vindrApi.getShadowLayer(context.tc.scenario.projectid, context.tc.scenario.scenario_id).then((result)=>{
			addLayer(result);
			setShadowData(result);
		});
		
	}
	const convertPadding = (value) => {
		
		var p = value-6;
		if(p<0)
			p=0;
		if(p>2)
			p=2;
		
		
		// 0->2 === 0->245px 
		p = (p*122.5);
		return p;
		
	}
	const setLayerOpacity = (l, opacity) => {
		if(l && opacity !== null){
			var opc = parseFloat(opacity);
			var layer = map.getLayer(l);
			//console.log(layer.type);
			if(!layer)
				return;
			
			if (layer.type === 'symbol')  {
				map.setPaintProperty(l, 'icon-opacity', opc);
				map.setPaintProperty(l, 'text-opacity', opc);
			}
			else if(layer.type === 'raster') {
				map.setPaintProperty(l, layer.type+'-opacity', opc);
			}
			else {
				const method = shadowData.method;
				const newScale = getScale(method).map((s, i) => ({
					...s,
					opacity: hiddenBands.has(i) ? 0 : s.opacity * opacity
				}));
				var op = paintOpacity(newScale, method);
				map.setPaintProperty(l, layer.type+'-opacity', op[layer.type+'-opacity']);
			}
		}
	}
	
	const getTurbineType = () => {
		
		
		const type = tc.scenario.turbine_types.find((t)=>{return tc.scenario.wtgSettings.turbineType == t.turbine_type});
		return type.turbine_name ?? '';
	}

	const handleCalculate = () => {
		vindrApi.startShadowLayer(context.tc.scenario.projectid, context.tc.scenario.scenario_id).then((result)=>{
			
			setShadowData(result);
			context.QN.current.show("Shadow calculation in progress. Reload page in a few minutes to see updated data.");
		});
	}

	
	return (
		<>
		{!!shadowData?.state &&
			<div className="card overlayShadow">
				<div className="row title">
					Shadow levels
					<span onClick={onClose} className="btn btn-close alt float-end"><X size={12} weight="bold" /></span>
				</div>
				{
				(shadowData.state == 'in_progress' || shadowData.state == 'waiting') &&
					<div className="my-3 mx-1">Status : Shadow calculation in progress… This may take a few minutes</div>
				}
				{
				shadowData.state == 'finished' &&
				<>
					<div className="my-3">
						Hours / year
						
						
						{!!shadowData && shadowData.method != 'REAL' && 
						<div className="branded-tooltip">
							<Info size={16} weight="bold" />
							<div className="text">
								<span><Info size={16} weight="bold" /> SHADOW  (Worst Case)</span>

								The SHADOW module (worst case) calculates the maximum possible shadow flicker by assuming that turbines operate continuously whenever the sun is shining, with no clouds, and with wind direction always aligned from the turbine to the receptor. It uses the positions and heights of turbines, the layout and receptors with omnidirectional windows, and the sun’s path throughout the year to determine how many hours of flicker could theoretically occur.
							</div>
						</div>
						}
						{!!shadowData && shadowData.method == 'REAL' && 
						<div className="branded-tooltip">
							<Info size={16} weight="bold" />
							<div className="text">
								<span><Info size={16} weight="bold" /> SHADOW - Flickering (real Case)</span>

								The SHADOW module (real case based on statistics) starts from the worst-case calculation, which assumes turbines operate nonstop under clear skies with wind always blowing toward the receptor, giving the maximum possible shadow flicker hours. The real-case method then reduces this result by factoring in how many hours turbines actually run each year, how often the wind blows in directions that cause flicker at specific receptors, and how much sunshine there is each month compared to theoretical daylight.
							</div>
						</div>
						}
					</div>
					<div className="scale">
						<span className="hide-all-link" onClick={()=>{
							const method = shadowData.method;
							const activeScale = getScale(method);
							const allHidden = hiddenBands.size === activeScale.length;
							const next = new Set();
							if (!allHidden) activeScale.forEach((_, i) => next.add(i));
							setHiddenBands(next);
							if (map.getLayer(layerId)) {
								const scale = activeScale.map((s, i) => ({
									...s,
									opacity: next.has(i) ? 0 : s.opacity * (opacity / 100)
								}));
								map.setPaintProperty(layerId, 'fill-opacity', paintOpacity(scale, method)['fill-opacity']);
							}
						}}>
							{hiddenBands.size === getScale(shadowData.method).length ? 'Show all' : 'Hide all'}
						</span>
						<ul>
							{
								getScale(shadowData.method).map((a, i)=>{
									const hidden = hiddenBands.has(i);
									return (
										<li key={i}>
											<span className="square" style={{backgroundColor:a.color, opacity: hidden ? 0.2 : a.opacity}}></span>
											{a.label}
											<span onClick={()=>handleToggleBand(i)} className={"band-eye"+(hidden ? " opacity-25" : "")}>
												<Eye size={16} weight="bold" />
											</span>
										</li>
									)
								})
							}
						</ul>
					</div>
					<Row>
						<Col xs="12 style-name pt-2">
							<b>Layer opacity (%)</b>
						</Col>
						<Col xs="12">
							<EditableRange wrpClassName="mb-3" className="opacity-range-input" min="0" max="100" step="1" value={opacity} defaultValue={100} onChange={(e)=>{handleOpacityChange(e.target.value);}} />
						</Col>
						<Col xs="12 mt-2">
							<b>Turbine type used: </b>
						</Col>
						<Col xs="12 mt-2 mb-4">
							{getTurbineType()}
						</Col>
					</Row>	
				</>
				}
			</div>
		}
		{!!shadowData && !shadowData.state &&
			<Modal className="modalShadow" show={true} onHide={onClose}  centered>
				<Modal.Header closeButton>
					<Modal.Title>Calculate shadow levels</Modal.Title>
				</Modal.Header>


						

				<Modal.Body>
					<Row className="mb-3">

						<Col xs="12" className="feedback-text mb-5">
							Shadow levels are not calculated for this scenario yet. This prosess takes a few minutes.
						</Col>
					</Row>
				</Modal.Body>


				<Modal.Footer>
					<Button variant="secondary" onClick={onClose}>Cancel</Button>
					<Button variant="primary" type="submit" onClick={handleCalculate}>Start calculation to continue</Button>
				</Modal.Footer>
						
					
			</Modal>
		}
		</>
		
	)
}
